// MCA Chicago — custom brand JS.
// Keep this file lean. App logic (member, min/max, POS) belongs in
// Museum OS theme app extensions, not here.

(function () {
  'use strict';

  // Footer year — any [data-mca-current-year] element gets the current year.
  document.querySelectorAll('[data-mca-current-year]').forEach(function (el) {
    el.textContent = String(new Date().getFullYear());
  });

  // Mega menu — opens on hover (pointer devices, desktop nav breakpoint)
  // with a short intent delay, like the live Expanse nav. Click, Escape,
  // outside-click and keyboard behaviour are kept for touch + a11y:
  //   - click on a closed trigger opens it
  //   - click on an open trigger follows data-mca-url (parent collection)
  //     when one exists, otherwise closes the panel
  var megaTriggers = document.querySelectorAll('[data-mca-mega-trigger]');
  if (megaTriggers.length) {
    var OPEN_DELAY = 80;
    var CLOSE_DELAY = 220;
    var openTimer = null;
    var closeTimer = null;
    var hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');

    var panelFor = function (trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      return panelId ? document.getElementById(panelId) : null;
    };

    var closeAll = function () {
      document.querySelectorAll('[data-mca-mega].is-open').forEach(function (panel) {
        panel.classList.remove('is-open');
        var trigger = document.querySelector(
          '[data-mca-mega-trigger][aria-controls="' + panel.id + '"]'
        );
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    };

    var open = function (trigger) {
      var panel = panelFor(trigger);
      if (!panel) return;
      closeAll();
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };

    var clearTimers = function () {
      if (openTimer) { window.clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) { window.clearTimeout(closeTimer); closeTimer = null; }
    };

    var scheduleClose = function () {
      clearTimers();
      closeTimer = window.setTimeout(closeAll, CLOSE_DELAY);
    };

    megaTriggers.forEach(function (trigger) {
      var panel = panelFor(trigger);
      if (!panel) return;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimers();
        if (panel.classList.contains('is-open')) {
          var url = trigger.getAttribute('data-mca-url') || '';
          if (url && url !== '#' && url.slice(-1) !== '#') {
            window.location.assign(url);
            return;
          }
          closeAll();
          return;
        }
        open(trigger);
      });

      // Hover intent (pointer devices only)
      trigger.addEventListener('mouseenter', function () {
        if (!hoverQuery.matches) return;
        clearTimers();
        openTimer = window.setTimeout(function () { open(trigger); }, OPEN_DELAY);
      });
      trigger.addEventListener('mouseleave', function () {
        if (!hoverQuery.matches) return;
        scheduleClose();
      });
      panel.addEventListener('mouseenter', function () {
        if (!hoverQuery.matches) return;
        clearTimers();
      });
      panel.addEventListener('mouseleave', function () {
        if (!hoverQuery.matches) return;
        scheduleClose();
      });

      // Keyboard: close when focus leaves the trigger + its panel
      panel.addEventListener('focusout', function (e) {
        var next = e.relatedTarget;
        if (next && (panel.contains(next) || next === trigger)) return;
        if (next) closeAll();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        clearTimers();
        closeAll();
      }
    });

    document.addEventListener('click', function (e) {
      if (
        !e.target.closest('[data-mca-mega]') &&
        !e.target.closest('[data-mca-mega-trigger]')
      ) {
        clearTimers();
        closeAll();
      }
    });
  }
})();
